/**
 * `<localization-form>` custom element (FR20, FR21, story 4.3).
 *
 * The native `{% form 'localization' %}` only changes country or language
 * when it is submitted; a bare <select> did nothing (review of 22/08, #2).
 * Choosing an option submits its form — Shopify's `return_to` keeps the
 * customer on the same page. Without JavaScript the <noscript> button does it.
 */
class LocalizationForm extends HTMLElement {
  connectedCallback() {
    this.querySelectorAll('select').forEach((select) => {
      select.addEventListener('change', () => select.form && select.form.submit());
    });
  }
}

if (!customElements.get('localization-form')) {
  customElements.define('localization-form', LocalizationForm);
}
